import styled from 'styled-components'

import { SECONDARY_TEXT_COLOR, CLICKABLE_COLOR } from '@CSSVars/colors'

export const _CollapseContainer = styled.div`
  ${({ containerCustomClass }) => (
    containerCustomClass || ''
  )}
`

export const _ToggleLabel = styled.label`
  display: block;
  position: relative;
  border-radius: 7px;
  transition: all 0.25s ease-out;
  pointer-events: none;
  width: 100%;
  max-height: 20000px;
  pointer-events: ${({ isCollapsible }) => (isCollapsible ? 'auto' : 'none')};

  @media screen and (max-width: 767px) {
    cursor: pointer;
    pointer-events: auto;
  }

`
export const _SeoText = styled.span.attrs({
  className: 'seo_text_collapsible',
})`
  display: block;
  margin-left: 0;
  margin-top: 4px;
  font-size: 12px;
  line-height: 22px;
  max-width: calc(100% - 22px);
  color: ${SECONDARY_TEXT_COLOR};
`

export const _SearchPageLink = styled.span`
  display: block;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 0;
  border: none;
  cursor: pointer;

  a {
    line-height: 22px;
    color: ${CLICKABLE_COLOR};
    text-decoration: underline;
  }

  @media screen and (max-width: 767px) {
    display: none;
  }

  @media print {
    display: none;
  }
`

export const _Icon = styled.span`
  display: none;

  @media screen and (max-width: 767px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0px;
    padding: 0;
    border: none;
    cursor: pointer;
  }

  @media print {
    display: none;
  }
`
export const _BarCont = styled.div`
  @media screen and (max-width: 767px) {
    width: 14px;
    height: 14px;
    position: relative;
  }
`
export const _Horizontal = styled.div`
  width: 100%;
  height: 3px;
  background: black;
  position: absolute;
  top: 50%;
  transition: transform 0.2s, opacity 0.25s;
  transform: rotate(0deg) translateZ(0);
`

export const _Vertical = styled.div`
  width: 100%;
  height: 3px;
  background: black;
  position: absolute;
  top: 50%;
  transform: rotate(90deg) translateZ(0);
  transition: transform 0.2s ease-in-out;
  backface-visibility: hidden;
  opacity: 0;
`

export const _Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  width: calc(100% - 14px);
  position: relative;
/*  display: inline-block;*/
  text-overflow: ellipsis;
  ${({ labelCustomClass }) => (
    labelCustomClass || ''
  )}

  @media screen and (max-width: 767px) {
    font-size: 18px;
  }
`

export const _VisibleContent = styled.div`
  ${({ visibleContentCustomClass }) => (
    visibleContentCustomClass ||
      `
        margin-top: 24px;
        position: relative;
        max-height: 20000px;
      `
  )}
`

export const _Content = styled.div`
  ${({ contentCustomClass }) => (
    contentCustomClass ||
      `
        margin-top: 24px;
        position: relative;
        max-height: 20000px;
      `
  )}
`

export const _ContentInner = styled.div`
  ${({ contentInnerCustomClass }) => (
    contentInnerCustomClass || ''
  )}
`

export const _SeperatorLine = styled.div`
  ${({ seperatorLineCustomClass }) => (
    seperatorLineCustomClass || ''
  )}
`
export const _CollapseInput = styled.input`
  ${({ inputCustomClass }) => (
    inputCustomClass ||
      `
        display: none;

        @media screen and (max-width: 767px) {
          &:checked + label {

          }
        }
      `
  )}

  &:checked + label {
    ${_SeoText} {
      //@media screen and (max-width: 767px) {
      //  display: none;
      //}
    }
    ${_Horizontal} {
      @media screen and (max-width: 767px) {
        transform: rotate(-270deg);
      }
    }
    ${_Vertical} {
      @media screen and (max-width: 767px) {
        transform: rotate(-180deg);
        opacity: 1;
      }
    }
    ~ ${_Content} {
      @media screen and (max-width: 767px) {
        display: none;
      }
    }
  }
`
